import { AppearanceDataType } from './appearance.enum';

export const appearanceModel = {
  currentType: AppearanceDataType.Type,
  tabs: [
    {
      type: AppearanceDataType.Draw,
      fileId: null,
      data: null,
    },
    {
      type: AppearanceDataType.Type,
      data: null,
      styles: {
        font: 'Lobster',
      },
    },
    {
      type: AppearanceDataType.Image,
      fileId: null,
      data: null,
    },
  ],
};
